import React from 'react';
import './IntroSection.css';

const IntroSection = () => {
  const intro = {
    description: "Data scientist with a strong foundation in analytics, machine learning, and data engineering, interested in building production-ready solutions."
  };

  const education = [
    {
      degree: "MSc in Data Science",
      institution: "Vellore Institute of Technology",
      year: "2024 - 2026",
      location: "Tamil Nadu, India"
    },
    {
      degree: "BSc in Computer Science",
      institution: "University of Mumbai",
      year: "2021 - 2024",
      location: "Mumbai, India"
    }
  ];

  const skills = {
    languages: ['Python', 'R', 'SQL'],
    frameworks: ['PyTorch', 'Scikit-learn', 'TensorFlow', 'Pandas', 'NumPy', 'PySpark'],
    tools: ['PowerBI', 'Tableau', 'Git', 'Fabric', 'Excel']
  };

  const experience = [
    {
      role: "Data Engineering Intern",
      company: "Capgemini",
      period: "Jan 2026 - Present",
        description: "Working on machine learning models and data analysis projects"
      },
    {
      role: "Subject Matter Expert",
      company: "House of Couton",
      period: "March 2025 - Oct 2025",
      description: "Helped clients with data science, data analysis and visualization projects. Provided one-on-one assitance to PG students."
    }
  ];

  return (
    <section className="intro-section section">
      <div className="section-container">
        <div className="intro-content-new">
          <p className="intro-description-new">{intro.description}</p>

          {/* Experience */}
          <div className="subsection">
            <h3 className="subsection-title">Experience</h3>
            <div className="timeline">
              {experience.map((exp, index) => (
                <div key={index} className="timeline-item">
                  <div className="timeline-marker"></div>
                  <div className="timeline-content">
                    <h4 className="timeline-title">{exp.role}</h4>
                    <p className="timeline-meta">{exp.company}</p>
                    <p className="timeline-period">{exp.period}</p>
                    <p className="timeline-description">{exp.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Skills */}
          <div className="subsection">
            <h3 className="subsection-title">Skills</h3>
            
            <div className="skills-category-new">
              <h4 className="skills-category-label">Languages</h4>
              <div className="skills-pills">
                {skills.languages.map((skill, index) => (
                  <span key={index} className="skill-pill">
                    {skill}
                  </span>
                ))}
              </div>
            </div>

            <div className="skills-category-new">
              <h4 className="skills-category-label">Frameworks & Libraries</h4>
              <div className="skills-pills">
                {skills.frameworks.map((skill, index) => (
                  <span key={index} className="skill-pill">
                    {skill}
                  </span>
                ))}
              </div>
            </div>

            <div className="skills-category-new">
              <h4 className="skills-category-label">Tools</h4>
              <div className="skills-pills">
                {skills.tools.map((skill, index) => (
                  <span key={index} className="skill-pill">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Education */}
          <div className="subsection">
            <h3 className="subsection-title">Education</h3>
            <div className="timeline">
              {education.map((edu, index) => (
                <div key={index} className="timeline-item">
                  <div className="timeline-marker"></div>
                  <div className="timeline-content">
                    <h4 className="timeline-title">{edu.degree}</h4>
                    <p className="timeline-meta">{edu.institution}</p>
                    <p className="timeline-period">{edu.year} | {edu.location}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
